export const ACTION_BASE_NAME = "ALERTS";
